export default __webpack_public_path__ + "static/media/login_cover.c424d226.png";